import { IBaseRequestResponseDataType } from '../../../../common/scripts/Connection/Connection';
import DataType from '../../../../tableEngine/Script/Game/Data/Config/DataStructure';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const LobbyPathName = {
    Login: 'login',
    Balance: 'player.balance',
    History: 'history.list',
    HistoryDetail: 'history.detail',
    HallOverview: 'lobby.overview',
    HallStats: 'lobby.stats',
    JackpotStatus: 'jackpot.status',
    JackpotRecord: 'jackpot.record',
    Favorite: 'favorite.update',
    GameLaunch: 'game.launch',
    GameAssets: 'lobby.games',
} as const;

export interface ILobbyRequestResponseDataType extends IBaseRequestResponseDataType {
    [LobbyPathName.Login]: [DataType.User.LoginRequestData, DataType.User.LoginResponseData];
    [LobbyPathName.Balance]: [undefined, DataType.Player.BalanceResponseData];
    [LobbyPathName.History]: [DataType.History.RequestData, DataType.History.ResponseData];
    [LobbyPathName.HistoryDetail]: [DataType.History.DetailRequestData, DataType.History.DetailResponseData];
    [LobbyPathName.HallOverview]: [DataType.Hall.OverviewRequestData, DataType.Hall.OverviewResponseData];
    [LobbyPathName.HallStats]: [undefined, DataType.Hall.StatsResponseData];
    [LobbyPathName.JackpotStatus]: [undefined, DataType.Jackpot.StatusResponseData];
    [LobbyPathName.JackpotRecord]: [DataType.Jackpot.RecordRequestData, DataType.Jackpot.RecordResponseData];
    [LobbyPathName.Favorite]: [DataType.Favorite.RequestData, DataType.Favorite.ResponseData | null];
    [LobbyPathName.GameLaunch]: [DataType.Game.LaunchRequestData, DataType.Game.LaunchResponseData];
    [LobbyPathName.GameAssets]: [undefined, DataType.Hall.OverviewResponseData];
}
